import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import { RootStore, useAppDispatch } from '../../../redux/store'
import MultiDayRequest from '../../MultiDayRequest'
import { RequestType } from '../../../models'
import Paragraph from '../../../shared/UI/Paragraph'
import { setSelectedDays } from '../../../redux/reducers/timeOffRequestsReducer'

interface AbsenceSummaryProps {
  show: boolean
  hasConflict?: boolean
}

function AbsenceSummary({ show, hasConflict = false }: AbsenceSummaryProps) {
  const dispatch = useAppDispatch()
  const { selectedDays } = useSelector((state: RootStore) => state.timeOff)

  const calculateTotalDays = useCallback((): number => {
    if (selectedDays?.some(day => day.checked)) {
      const daysToCalculate = selectedDays.filter(x => x.checked)
      if (daysToCalculate.length === 0) {
        return 0
      }
      return selectedDays
        .filter(x => x.checked)
        .map(selectedDay => (!Number.isNaN(selectedDay.hours!) ? selectedDay.hours! : 0))
        .reduce((accumulator, currentValue) => {
          if (!accumulator && accumulator !== 0) {
            return 0
          }
          if (!currentValue) {
            return accumulator
          }
          return accumulator + currentValue
        })
    }
    return 0
  }, [selectedDays])

  const updateHours = useCallback(
    (selectedDay: Date, hours: string | null) => {
      if (selectedDays) {
        const updatedDay = selectedDays.find(day => day.day!.getTime() === selectedDay.getTime())
        if (updatedDay) {
          let hoursToFloat = hours ? parseFloat(hours) : 0
          if (hoursToFloat < 0) {
            hoursToFloat = 0.0
          }
          updatedDay.hours = hoursToFloat
          dispatch(setSelectedDays([...selectedDays]))
        }
      }
    },
    [dispatch, selectedDays]
  )

  const updateCheckedDay = useCallback(
    (selectedDay: Date, hours: string) => {
      if (selectedDays) {
        const updatedDay = selectedDays.find(day => day.day!.getTime() === selectedDay.getTime())
        if (updatedDay) {
          updatedDay.checked = !updatedDay.checked
          dispatch(setSelectedDays([...selectedDays]))
        }
      }
    },
    [dispatch, selectedDays]
  )

  if (!show) {
    return null
  }

  return (
    <>
      <Grid item xs={12}>
        <MultiDayRequest
          type={RequestType.HOLIDAY}
          cardTitle="Holiday"
          totalRequestedHours={calculateTotalDays()}
          updateHours={updateHours}
          updateCheckedDay={updateCheckedDay}
          summaryTitle="Absence Summary"
          summaryOnly
          isLoading={false}
          dataTestId="MyActions-Absense"
        />
      </Grid>
      {hasConflict && (
        <Grid item xs={12}>
          <Paragraph color="#E75E5E" weight="bold">
            Clash message.
          </Paragraph>
        </Grid>
      )}
    </>
  )
}

export default AbsenceSummary
